console.log('Ready javascript');

window.initRepellentMap = function(){
  var locator = document.querySelector('.c-repellent__locator');
  var mapElement = document.getElementById('repellent-map');

  if (!locator || !mapElement || !window.google || !window.google.maps) {
    return;
  }

  if (mapElement.getAttribute('data-map-ready') === 'true' || !mapElement.offsetWidth) {
    return;
  }

  var points = [];
  var rawPoints = locator.getAttribute('data-repellent-map-points');

  try {
    points = JSON.parse(rawPoints || '[]');
  } catch(e) {
    points = [];
  }

  if (!points.length) {
    return;
  }

  mapElement.innerHTML = '';
  mapElement.setAttribute('data-map-ready', 'true');

  var fallbackCenter = { lat: 41.950992, lng: 2.791179 };
  var map = new google.maps.Map(mapElement, {
    center: fallbackCenter,
    zoom: 10,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: true
  });
  var bounds = new google.maps.LatLngBounds();
  var infoWindow = new google.maps.InfoWindow();
  var markers = [];
  var markerCount = 0;
  var cards = document.querySelectorAll('.js-repellent-sales-point');
  var markerSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="56" viewBox="0 0 42 56"><path fill="#4668AF" d="M21 0C9.4 0 0 9.4 0 21c0 15.8 21 35 21 35s21-19.2 21-35C42 9.4 32.6 0 21 0Z"/><circle cx="21" cy="21" r="8.5" fill="#ffffff"/></svg>';
  var markerIcon = {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(markerSvg),
    scaledSize: new google.maps.Size(32, 43),
    anchor: new google.maps.Point(16, 43)
  };

  function setActivePoint(index) {
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-active');
    }

    if (cards[index]) {
      cards[index].classList.add('is-active');
    }
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(value || ''));
    return div.innerHTML;
  }

  function markerContent(point) {
    return '<strong>' + escapeHtml(point.name) + '</strong><br>' + escapeHtml(point.address) + '<br>' + escapeHtml(point.city);
  }

  function addMarker(point, position, index) {
    var marker = new google.maps.Marker({
      icon: markerIcon,
      map: map,
      position: position,
      title: point.name
    });

    markers[index] = marker;
    markerCount++;
    bounds.extend(position);
    map.fitBounds(bounds);

    if (markerCount === 1) {
      map.setZoom(14);
    }

    marker.addListener('click', function(){
      setActivePoint(index);
      infoWindow.setContent(markerContent(point));
      infoWindow.open(map, marker);
    });
  }

  for (var i = 0; i < points.length; i++) {
    (function(point, index){
      var lat = parseFloat(point.lat);
      var lng = parseFloat(point.lng);

      if (!isNaN(lat) && !isNaN(lng)) {
        addMarker(point, { lat: lat, lng: lng }, index);
      }
    })(points[i], i);
  }

  for (var j = 0; j < cards.length; j++) {
    cards[j].addEventListener('click', function(){
      var index = parseInt(this.getAttribute('data-repellent-point'), 10);
      var marker = markers[index];

      setActivePoint(index);

      if (marker) {
        map.panTo(marker.getPosition());
        map.setZoom(14);
        infoWindow.setContent(markerContent(points[index]));
        infoWindow.open(map, marker);
      }
    });
  }
};

// Mobile > all touchstar DOM perfect Iphone
document.addEventListener("touchstart", function(){}, true);

jQuery( document ).ready(function( $ ) {


$("#js-eventClick-show-fragment-text__c-the-lice").click(function(){
  this.remove();
  $('#js-layer-fragment-text__c-the-lice').removeClass('dn').addClass('e-fade-in');
});
$("#js-eventClick-show__c-address").click(function(){
  this.remove();
  $('#js-layer__c-address').removeClass('dn').addClass('e-fade-in');
});


$('#js-clickEvent--c-menu__btn-mobile').click(function(){


  $('#js-clickEvent--c-menu__btn-mobile').toggleClass('is-active');
  $('#body').toggleClass('is-active-menu-mobile');
});

// anchor link
 // Add class menu reference archos url load page
 if (window.location.hash!=""){
  var menu__top = document.getElementById("menu-top");
  menu__top.className = "";
  var archos = window.location.hash.substr(1);
  menu__top.classList.add('item-'+archos);
}



// Resize window for web
window.addEventListener("scroll", resizeFunction);
window.addEventListener("resize", resizeFunction);
window.addEventListener("load", resizeFunction);


function resizeFunction() {
  var bodyHeight = document.documentElement.clientHeight;
  //console.log(window.pageYOffset);
}


window.addEventListener("scroll",recorrido);
function recorrido(){
      // sectors = ["empresa","distribucio","elaboracio-propia","hosteleria","contacte"];
      sectors = ["0","1","2","3","4"];

      pixelTop = [];for (var i = 0; i < sectors.length; i++) {

        d = document.getElementById(sectors[i]);

        if (!d) {
          continue;
        }
        
        pixelTop[i] = d.offsetTop - window.pageYOffset-document.getElementById("header").offsetHeight;

        if (pixelTop[i]<= document.getElementById("header").offsetHeight) {


          // console.log(d.id + ' : ' + d.offsetTop +  ' : ' + pixelTop[i]);


          var menu__top = document.getElementById("menu-top");



          menu__top.className = "";
          menu__top.classList.add('item-'+sectors[i]);

          // if ( d.id == "4" && pixelTop[i]<-200){
          //   menu__top.className = "";
          //   menu__top.classList.add('item-5');
          // }
        }
      }
    }

$('.js-repellent-tab').on('click', function(){
  var tab = $(this).data('repellent-tab');
  var $section = $(this).closest('.c-repellent');

  $section.find('.js-repellent-tab').removeClass('is-active').attr('aria-selected', 'false');
  $(this).addClass('is-active').attr('aria-selected', 'true');

  $section.find('[data-repellent-panel]').removeClass('is-active').attr('hidden', true);
  $section.find('[data-repellent-panel="'+tab+'"]').addClass('is-active').removeAttr('hidden');

  $section.find('video').each(function(){
    this.pause();
  });

  if (tab === 'how') {
    var video = $section.find('.js-repellent-video').get(0);

    if (video && video.getAttribute('data-tab-autoplayed') !== 'true') {
      video.setAttribute('data-tab-autoplayed', 'true');

      window.setTimeout(function(){
        var panel = video.closest('[data-repellent-panel]');

        if (!panel || panel.hasAttribute('hidden')) {
          return;
        }

        video.autoplay = true;
        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function(){});
        }
      }, 2000);
    }
  }

  if (tab === 'sales') {
    window.setTimeout(function(){
      window.initRepellentMap();
    }, 50);
  }
});

$('.js-repellent-video-language').on('click', function(){
  var button = this;
  var videoContainer = button.closest('.c-repellent__videos');
  var video = videoContainer ? videoContainer.querySelector('.js-repellent-video') : null;
  var source = video ? video.querySelector('source') : null;
  var nextSource = button.getAttribute('data-video-src');

  if (!video || !source || !nextSource || source.getAttribute('src') === nextSource) {
    return;
  }

  var languageButtons = videoContainer.querySelectorAll('.js-repellent-video-language');

  for (var i = 0; i < languageButtons.length; i++) {
    languageButtons[i].classList.remove('is-active');
    languageButtons[i].setAttribute('aria-pressed', 'false');
  }

  button.classList.add('is-active');
  button.setAttribute('aria-pressed', 'true');
  video.pause();
  video.autoplay = true;
  video.setAttribute('poster', button.getAttribute('data-video-poster') || '');
  source.setAttribute('src', nextSource);
  video.load();

  var playPromise = video.play();

  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(function(){});
  }
});



// anchor link
// Add smooth scrolling to all links
$("a").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {

      document.getElementById('body').classList.remove('is-active-menu-mobile');
      document.getElementById('js-clickEvent--c-menu__btn-mobile').classList.remove('is-active');

      $('.header__menu').removeClass('is-active');
      
      // Prevent default anchor click behavior
      // event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      var headerHeight = document.getElementsByTagName("header");

      var offsetHeight = document.getElementById('header').offsetHeight;


      if (headerHeight[0].classList != "fixed"){
        
        var topPage = $(hash).offset().top - offsetHeight;
        console.log(topPage);
      } else {
        var topPage = $(hash).offset().top;
    }

    $('html, body').animate({
      scrollTop: topPage
    }, 800, function(){

        //console.log($(hash).offset().top);
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
        var archos = window.location.hash.substr(1);
        var headerHeight = document.getElementsByTagName("header");
      });
    } // End if


  });


 $( window).scroll(function() {
      if ($(window).scrollTop()> 300 ) {
        $('#header').addClass('is-active');
      } if ($(window).scrollTop()< 120 ) {
        $('#header').removeClass('is-active');
      }
    });

});
